jQuery(document).ready(function() {
	var $ = jQuery;
	// if(jQuery('.document-library-wrapper .action_button').length > 0){
	// 	jQuery('.document-library-wrapper .action_button').on('click',function(){
	// 		jQuery(this).toggleClass('open');
	// 		jQuery(this).next('.action_options').slideToggle();
	// 	});
	// }
	$('body').on('click', function(e){
		if(!$(e.target).is('.action_options') && !jQuery(e.target).is('.action_options *')){
			$('.action_button').removeClass('open');
			$('.action_options').slideUp();
		}
	});

	if($('.document-library-wrapper .action_button').length > 0){
		$('html,body').on('click','.document-library-wrapper .action_button', function (event) {
	
			event.stopPropagation();
			$('.document-library-wrapper .action_options').slideUp();
			$('.document-library-wrapper .action_button').removeClass('open');
		
			if($(this).next('.action_options').is(':visible')){
				$(this).removeClass('open');
				$(this).next('.action_options').slideUp();
			} 
			else{
				$(this).addClass('open');
				$(this).next('.action_options').slideDown();
			}
		});
	}
	

}); //Document Ready End
